export default {
	colors: {
		black1000: '#000000',
		black900: '#2C2C2C',
		gray1000: '#C8C8C8',
		lightGray1000: '#DEDEDE',
		white1000: '#FFFFFF',
		error1000: '#C60000',
	},

	mediaQuery: {
		desktopSizeXL: '2560px',
		desktopSizeL: '1920px',
		desktopSizeM: '1536px',
		desktopSizeS: '1366px',
		tabletSize: '1280px',
		tabletSizeX: '1024px',
		tabletSizeS: '768px',

		desktopSizeXLMin: '2559px',
		desktopSizeLMin: '1919px',
		desktopSizeMMin: '1535px',
		desktopSizeSMin: '1365px',
		tabletSizeMin: '1279px',
		tabletSizeXMin: '1023px',
		tabletSizeSMin: '767px',
	},
	form: {
		colors: {
			//! Box Shadow
			boxShadowColor: 'unset',

			//! Empty Text Color
			emptyTextColor: '#C8C8C8',

			//! Message colors
			successMessageColor: '#4CAF50',
			successMessageBorderColor: '#4CAF50',
			successMessageBgColor: 'rgba(76, 175, 80, 0.1)',
			errorMessageColor: '#C60000',
			errorMessageBorderColor: '#C60000',
			errorMessageBgColor: 'rgba(222, 85, 78, 0.1)',

			//! Label
			labelColor: '#000000',
			labelHoverColor: '',
			labelFocusColor: '',
			labelActiveColor: '',
			labelErrorColor: '#000000',
			labelDisabledColor: '#C8C8C8',

			//! Input
			inputColor: '#000000',
			inputHoverColor: '',
			inputFocusColor: '#000000',
			inputActiveColor: '',
			inputErrorColor: '#000000',
			inputDisabledColor: '#C8C8C8',

			inputPlaceholderColor: 'rgba(0, 0, 0, 0.4)',
			inputPlaceholderHoverColor: '',
			inputPlaceholderFocusColor: '#000000',
			inputPlaceholderActiveColor: '',
			inputPlaceholderErrorColor: '#000000',
			inputPlaceholderDisabledColor: '',

			inputBorderColor: '#C8C8C8',
			inputBorderHoverColor: '',
			inputBorderFocusColor: 'unset',
			inputBorderActiveColor: '',
			inputBorderErrorColor: '#000000',
			inputBorderDisabledColor: '#C8C8C8',

			inputBgColor: '#FFFFFF',
			inputHoverBgColor: '#FFFFFF',
			inputFocusBgColor: '#FFFFFF',
			inputActiveBgColor: '#FFFFFF',
			inputErrorBgColor: '#FFFFFF',
			inputDisabledBgColor: '#C8C8C8',

			//! Select
			selectColor: '#000000',
			selectHoverColor: '#000000',
			selectFocusColor: '#000000',
			selectActiveColor: '#000000',
			selectErrorColor: '#000000',
			selectDisabledColor: '#C8C8C8',

			selectPlaceholderColor: 'rgba(0, 0, 0, 0.4)',
			selectPlaceholderHoverColor: '#000000',
			selectPlaceholderFocusColor: '#000000',
			selectPlaceholderActiveColor: '#000000',
			selectPlaceholderErrorColor: '#000000',
			selectPlaceholderDisabledColor: '#C8C8C8',

			selectBorderColor: '#000000',
			selectBorderHoverColor: '#000000',
			selectBorderFocusColor: '#000000',
			selectBorderActiveColor: '#000000',
			selectBorderErrorColor: '#000000',
			selectBorderDisabledColor: '#C8C8C8',

			selectBgColor: '#FFFFFF',
			selectHoverBgColor: '#FFFFFF',
			selectFocusBgColor: '#FFFFFF',
			selectActiveBgColor: '#FFFFFF',
			selectErrorBgColor: '#FFFFFF',
			selectDisabledBgColor: '#C8C8C8',

			selectOptionColor: '#FFFFFF',
			selectOptionHoverColor: '#FFFFFF',
			selectOptionFocusColor: '#FFFFFF',
			selectOptionActiveColor: '#FFFFFF',
			selectOptionErrorColor: '#FFFFFF',
			selectOptionDisabledColor: '#C8C8C8',

			selectOptionBgColor: '#000000',
			selectOptionHoverBgColor: '#000000',
			selectOptionFocusBgColor: '#000000',
			selectOptionActiveBgColor: '#000000',
			selectOptionErrorBgColor: '#000000',
			selectOptionDisabledBgColor: '#C8C8C8',

			//! Radio
			radioBorderColor: '#C8C8C8',
			radioBorderActiveColor: '#000000',
			radioBgColor: '#FFFFFF',
			radioActiveBgColor: '#000000',

			//! Upload
			uploadBgColor: 'rgba(0, 0, 0, 0.02)',
			uploadBorderColor: '#d9d9d9',
		},
	},
};
